import InputPassword from '../Form/Fields/InputPassword';

const IdentityVerification = () => {
  return (
    <div className="account-verification">
      <span className="cdm-field-label">Mot de passe actuel <span className="text-danger">*</span></span>
      <InputPassword
        name="currentPassword"
        placeholder="Mot de passe actuel"
        validationRules={{ required: "Le mot de passe est obligatoire" }}
      />
    </div>
  );
};

export default IdentityVerification;
